var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDC2B1C1-93AA-4DC3-A10F-51F4B9641219") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.00043365,0 C12.4184735,0 16,3.58162353 16,8.00021683 C16,12.4183765 12.4184735,16 8.00043365,16 C3.58152645,16 7.10542736e-15,12.4183765 7.10542736e-15,8.00021683 C7.10542736e-15,3.58162353 3.58152645,0 8.00043365,0 Z M8.00043365,1.33333333 C4.31797009,1.33333333 1.33333333,4.31793923 1.33333333,8.00021683 C1.33333333,11.6821166 4.31802597,14.6666667 8.00043365,14.6666667 C11.6820858,14.6666667 14.6666667,11.6820049 14.6666667,8.00021683 C14.6666667,4.31805098 11.6821417,1.33333333 8.00043365,1.33333333 Z M8,4 C8.36818983,4 8.66666667,4.29847683 8.66666667,4.66666667 L8.666,7.333 L11.3333333,7.33333333 C11.7015232,7.33333333 12,7.63181017 12,8 C12,8.36818983 11.7015232,8.66666667 11.3333333,8.66666667 L8.666,8.666 L8.66666667,11.3333333 C8.66666667,11.7015232 8.36818983,12 8,12 C7.63181017,12 7.33333333,11.7015232 7.33333333,11.3333333 L7.333,8.666 L4.66666667,8.66666667 C4.29847683,8.66666667 4,8.36818983 4,8 C4,7.63181017 4.29847683,7.33333333 4.66666667,7.33333333 L7.333,7.333 L7.33333333,4.66666667 C7.33333333,4.29847683 7.63181017,4 8,4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category-Template---Final-Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sub-Category-Page-/-Option-1-/-Review-3",
    transform: "translate(-203.000000, -3659.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(101.000000, 3654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Search-Plus",
    transform: "translate(102.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#00095B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/search-plus.397b915b104dacd9bfe04d9d0b4464cf.svg";
export { ForwardRef as ReactComponent };